var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/map"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.7375 16.1445C11.415 16.1445 11.0925 16.077 10.83 15.9495L6.89253 13.977C6.66753 13.8645 6.22503 13.872 6.00753 13.9995L4.23753 15.012C3.47253 15.447 2.68503 15.507 2.09253 15.1545C1.49253 14.8095 1.15503 14.1045 1.15503 13.2195V5.92953C1.15503 5.24703 1.60503 4.47453 2.19753 4.13703L5.44503 2.27703C5.99253 1.96203 6.82503 1.93953 7.38753 2.22453L11.325 4.19703C11.55 4.30953 11.985 4.29453 12.21 4.17453L13.9725 3.16953C14.7375 2.73453 15.525 2.67453 16.1175 3.02703C16.7175 3.37203 17.055 4.07703 17.055 4.96203V12.2595C17.055 12.942 16.605 13.7145 16.0125 14.052L12.765 15.912C12.48 16.062 12.105 16.1445 11.7375 16.1445ZM6.48003 12.777C6.80253 12.777 7.12503 12.8445 7.38753 12.972L11.325 14.9445C11.55 15.057 11.985 15.042 12.21 14.922L15.4575 13.062C15.6975 12.927 15.93 12.522 15.93 12.252V4.95453C15.93 4.48203 15.795 4.12953 15.5475 3.99453C15.3075 3.85953 14.9325 3.91203 14.5275 4.14453L12.765 5.14953C12.2175 5.46453 11.385 5.48703 10.8225 5.20203L6.88503 3.22953C6.66003 3.11703 6.22503 3.13203 6.00003 3.25203L2.75253 5.11203C2.51253 5.24703 2.28003 5.65203 2.28003 5.92953V13.227C2.28003 13.6995 2.41503 14.052 2.65503 14.187C2.89503 14.3295 3.27003 14.2695 3.68253 14.037L5.44503 13.032C5.73753 12.8595 6.11253 12.777 6.48003 12.777Z",
    fill: "#053CC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.41998 13.3994C6.11248 13.3994 5.85748 13.1444 5.85748 12.8369V3.08691C5.85748 2.77941 6.11248 2.52441 6.41998 2.52441C6.72748 2.52441 6.98248 2.77941 6.98248 3.08691V12.8369C6.98248 13.1444 6.72748 13.3994 6.41998 13.3994Z",
    fill: "#053CC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.7975 15.6493C11.49 15.6493 11.235 15.3943 11.235 15.0868V5.05176C11.235 4.74426 11.49 4.48926 11.7975 4.48926C12.105 4.48926 12.36 4.74426 12.36 5.05176V15.0868C12.36 15.3943 12.105 15.6493 11.7975 15.6493Z",
    fill: "#053CC8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.343d943c6fe693c22d6373ab11f5d7fc.svg";
export { ForwardRef as ReactComponent };